import ActivationSvg from "../assets/alertsAndBadges/activation.svg"
import AlertSvg from "../assets/alertsAndBadges/alert.svg"
import AssessmentSvg from "../assets/alertsAndBadges/assessment.svg"
import BedTimeSvg from "../assets/alertsAndBadges/bed-time.svg"
import BreatheSvg from "../assets/alertsAndBadges/breathe.svg"
import CalendarSvg from "../assets/alertsAndBadges/calendar.svg"
import CheckInSvg from "../assets/alertsAndBadges/check-in.svg"
import ConnectSvg from "../assets/alertsAndBadges/connect.svg"
import CopeSvg from "../assets/alertsAndBadges/cope.svg"
import DistractionsSvg from "../assets/alertsAndBadges/distractions.svg"
import DoneSvg from "../assets/alertsAndBadges/done.svg"
import DrivingSvg from "../assets/alertsAndBadges/driving.svg"
import EnjoymentSvg from "../assets/alertsAndBadges/enjoyment.svg"
import ExerciseSvg from "../assets/alertsAndBadges/exercise.svg"
import FriendsSvg from "../assets/alertsAndBadges/friends.svg"
import GoalsSvg from "../assets/alertsAndBadges/goals.svg"
import HeartSvg from "../assets/alertsAndBadges/heart.svg"
import HomeSvg from "../assets/alertsAndBadges/home.svg"
import InfoSvg from "../assets/alertsAndBadges/info.svg"
import InsightsSvg from "../assets/alertsAndBadges/insights.svg"
import KeyboardSvg from "../assets/alertsAndBadges/keyboard.svg"
import LanguageSvg from "../assets/alertsAndBadges/language.svg"
import LearnSvg from "../assets/alertsAndBadges/learn.svg"
import LifePreserverSvg from "../assets/alertsAndBadges/life-preserver.svg"
import LockSvg from "../assets/alertsAndBadges/lock.svg"
import MailSvg from "../assets/alertsAndBadges/mail.svg"
import NudgeSvg from "../assets/alertsAndBadges/nudge.svg"
import PencilSvg from "../assets/alertsAndBadges/pencil.svg"
import PhoneSvg from "../assets/alertsAndBadges/phone.svg"
import PlusSvg from "../assets/alertsAndBadges/plus.svg"
import PodcastSvg from "../assets/alertsAndBadges/podcast.svg"
import ProfessionalsSvg from "../assets/alertsAndBadges/professionals.svg"
import ProgressSvg from "../assets/alertsAndBadges/progress.svg"
import QuestionSvg from "../assets/alertsAndBadges/question.svg"
import SafeSvg from "../assets/alertsAndBadges/safe.svg"
import SavorSvg from "../assets/alertsAndBadges/savor.svg"
import SettingsSvg from "../assets/alertsAndBadges/settings.svg"
import SharingSvg from "../assets/alertsAndBadges/sharing.svg"
import SleepSvg from "../assets/alertsAndBadges/sleep.svg"
import SoftwareSvg from "../assets/alertsAndBadges/software.svg"
import StationarySvg from "../assets/alertsAndBadges/stationary.svg"
import TrophySvg from "../assets/alertsAndBadges/trophy.svg"
import TvSvg from "../assets/alertsAndBadges/tv.svg"
import ViraSvg from "../assets/alertsAndBadges/vira.svg"
import WakeUpSvg from "../assets/alertsAndBadges/wake-up.svg"
import WalkingSvg from "../assets/alertsAndBadges/walking.svg"
import WarningSvg from "../assets/alertsAndBadges/warning.svg"
import XSvg from "../assets/alertsAndBadges/x.svg"

/**
 * A mapping of alert and badge SVG filenames to their respective SVG modules.
 * The keys are the filenames of the SVGs, and the values are the imported SVG modules.
 *
 * @type {Object.<string, any>}
 */
const alertsAndBadges: { [key: string]: any } = {
  "activation.svg": ActivationSvg,
  "alert.svg": AlertSvg,
  "assessment.svg": AssessmentSvg,
  "bed-time.svg": BedTimeSvg,
  "breathe.svg": BreatheSvg,
  "calendar.svg": CalendarSvg,
  "check-in.svg": CheckInSvg,
  "connect.svg": ConnectSvg,
  "cope.svg": CopeSvg,
  "distractions.svg": DistractionsSvg,
  "done.svg": DoneSvg,
  "driving.svg": DrivingSvg,
  "enjoyment.svg": EnjoymentSvg,
  "exercise.svg": ExerciseSvg,
  "friends.svg": FriendsSvg,
  "goals.svg": GoalsSvg,
  "heart.svg": HeartSvg,
  "home.svg": HomeSvg,
  "info.svg": InfoSvg,
  "insights.svg": InsightsSvg,
  "keyboard.svg": KeyboardSvg,
  "language.svg": LanguageSvg,
  "learn.svg": LearnSvg,
  "life-preserver.svg": LifePreserverSvg,
  "lock.svg": LockSvg,
  "mail.svg": MailSvg,
  "nudge.svg": NudgeSvg,
  "pencil.svg": PencilSvg,
  "phone.svg": PhoneSvg,
  "plus.svg": PlusSvg,
  "podcast.svg": PodcastSvg,
  "professionals.svg": ProfessionalsSvg,
  "progress.svg": ProgressSvg,
  "question.svg": QuestionSvg,
  "safe.svg": SafeSvg,
  "savor.svg": SavorSvg,
  "settings.svg": SettingsSvg,
  "sharing.svg": SharingSvg,
  "sleep.svg": SleepSvg,
  "software.svg": SoftwareSvg,
  "stationary.svg": StationarySvg,
  "trophy.svg": TrophySvg,
  "tv.svg": TvSvg,
  "vira.svg": ViraSvg,
  "wake-up.svg": WakeUpSvg,
  "walking.svg": WalkingSvg,
  "warning.svg": WarningSvg,
  "x.svg": XSvg,
}

export { alertsAndBadges }
